import _ from 'lodash';
import * as types from '../mutation-types';
import groups from '../../api/groups';

const state = {
  groups: [
    {
      id: null,
      journey_id: null,
      number: 0,
      name: null,
      description: null,
      journey: {
        name: null
      }
    }
  ],
  selected: {
    id: null,
    journey_id: null,
    number: 0,
    name: null,
    description: null,
    journey: {
      name: null
    }
  }
};

const getters = {
  Groups: state => state.groups,
  SelectedGroup: state => state.selected
};

const actions = {
  getGroups({ commit }) {
    groups.getGroups().then(groups => {
      commit(types.SET_GROUPS, groups.data);
    });
  },
  selectGroup({ commit, dispatch }, group) {
    commit(types.SET_SELECTED_GROUP, group);
    const questions = _.orderBy(group.questions, ['pivot.sort_order'], ['asc']);
    if (!_.isUndefined(questions[0])) {
      dispatch('selectQuestion', { id: questions[0].id });
    } else {
      dispatch('unsetSelectQuestion');
    }
  },
  unsetSelectedGroup({ commit, dispatch }) {
    commit(types.UNSET_SELECTED_GROUP);
    dispatch('unsetSelectQuestion');
  },
  updateGroup({ commit, dispatch }, { id, updates }) {
    groups.updateGroup(id, updates).then(group => {
      dispatch('addNotification', {
        text: 'Question section updates saved',
        bottom: true,
        left: true,
        colour: 'success'
      });
      commit(types.UPDATE_GROUP, group.data);
    });
  },
  updateGroupOrder({ commit }, { newOrder }) {
    commit(types.UPDATE_GROUP_ORDER, newOrder);
    groups.updateGroupOrder(newOrder);
  },
  addGroup({ dispatch }, { group }) {
    groups.addGroup(group).then(() => {
      dispatch('addNotification', {
        text: 'Question section added',
        bottom: true,
        left: true,
        colour: 'success'
      });
      dispatch('getJourneyTypes');
    });
  }
};

const mutations = {
  [types.SET_GROUPS](state, groups) {
    state.groups = groups;
  },
  [types.UPDATE_GROUP](state, group) {
    const index = _.findIndex(state.groups, ['id', group.id]);
    if (index >= 0) {
      _.merge(state.groups[index], group);
    }
    if (state.selected.id === group.id) {
      _.merge(state.selected, group);
    }
  },
  [types.SET_SELECTED_GROUP](state, group) {
    state.selected = group;
  },
  [types.UNSET_SELECTED_GROUP](state) {
    state.selected = {
      id: null,
      journey_id: null,
      number: 0,
      name: null,
      description: null,
      journey: {
        name: null
      }
    };
  },
  [types.UPDATE_QUESTION_ORDER](state, newOrder) {
    _.forEach(newOrder, function(item, key) {
      const index = _.findIndex(state.selected.questions, ['id', key]);
      if (index >= 0) {
        state.selected.questions[index].pivot.sort_order = item.sort_order;
      }
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
